// extracted by mini-css-extract-plugin
export default {"container":"index_container__sJGdT","discover":"index_discover__sfx-B","sktcontainer":"index_sktcontainer__7lNtZ"};